module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.checkCreds.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "login-sub text-center"
  }, [(this.$route.params.id == 'admin') ? _c('h1', {
    staticClass: "sendi-admin-login-title"
  }, [_vm._v("Acceso de administradores")]) : _vm._e(), _vm._v(" "), (this.$route.params.id == 'oper') ? _c('h1', {
    staticClass: "sendi-admin-login-title"
  }, [_vm._v("Acceso de operadores")]) : _vm._e(), _vm._v(" "), (this.$route.params.id !== 'admin' && this.$route.params.id !== 'oper') ? _c('h1', {
    staticClass: "sendi-admin-login-title"
  }, [_vm._v("Acceso de clientes")]) : _vm._e()]), _vm._v(" "), _c('div', {}, [_c('div', {
    staticClass: "form-group"
  }, [(this.$route.params.id !== 'admin' && this.$route.params.id !== 'oper') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Contraseña),
      expression: "Contraseña"
    }],
    class: 'form-control login__input ' + _vm.validationUser,
    attrs: {
      "type": "email",
      "id": "email",
      "autocomplete": "username",
      "placeholder": "Correo electrónico",
      "aria-label": "Correo electrónico"
    },
    domProps: {
      "value": (_vm.Contraseña)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.Contraseña = $event.target.value
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    class: 'form-control login__input ' + _vm.validationUser,
    attrs: {
      "type": "text",
      "id": "email",
      "autocomplete": "username",
      "placeholder": "Tu usuario",
      "aria-label": "Usuario"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.responseUser) ? _c('small', {
    staticClass: "text-danger d-flex align-items-start"
  }, [_vm._v(_vm._s(_vm.responseUser))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    class: 'form-control login__input ' + _vm.validationPass,
    attrs: {
      "type": "password",
      "id": "password",
      "placeholder": "Tu contraseña",
      "aria-label": "Contraseña",
      "autocomplete": "current-password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.responsePass) ? _c('small', {
    staticClass: "text-danger d-flex align-items-start"
  }, [_vm._v(_vm._s(_vm.responsePass))]) : _vm._e(), _vm._v(" "), (this.$route.params.id == 'admin' || this.$route.params.id == 'oper') ? _c('router-link', {
    staticClass: "registerAnchor account",
    attrs: {
      "to": '/login/' + this.$route.params.id + '/changepassword'
    }
  }, [_vm._v("¿Olvidaste tu contraseña?")]) : _vm._e()], 1), _vm._v(" "), _c('button', {
    class: 'btn btn-primary btn-block btn-round ' + _vm.loading,
    attrs: {
      "type": "submit",
      "id": "submit"
    }
  }, [_vm._v("Continuar")]), _vm._v(" "), (this.$route.params.id !== 'admin' && this.$route.params.id !== 'oper') ? _c('div', {}) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-word"
  })]), _vm._v(" "), (_vm.response) ? _c('div', [_c('p', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.response))])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c921d2c4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LoginForm.vue
// module id = 1913
// module chunks = 1